import { render } from "./Intro.vue?vue&type=template&id=28f7c178&scoped=true"
import script from "./Intro.vue?vue&type=script&lang=js"
export * from "./Intro.vue?vue&type=script&lang=js"

import "./Intro.vue?vue&type=style&index=0&id=28f7c178&lang=stylus&scoped=true"
script.render = render
script.__scopeId = "data-v-28f7c178"

export default script